(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["wonder-bundle-builder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wonder-bundle-picker')) {
    customElements.define('wonder-bundle-picker', class extends HTMLElement {
      connectedCallback() {
        this.choices = [...this.querySelectorAll('input[type="radio"]')];
        this.onChange = () => this.update();
        this.addEventListener('change', this.onChange);
        this.update();
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
      }

      update() {
        const selected = this.choices.find((choice) => choice.checked);
        this.choices.forEach((choice) => {
          choice.closest('.wonder-bundle-choice').dataset.selected = String(choice.checked);
        });
        if (!selected) return;
        const gallery = this.closest('.shopify-section')?.querySelector('[data-wonder-christmas-pair-gallery]');
        const photo = selected.closest('.wonder-bundle-choice').querySelector('img');
        if (!gallery || !photo) return;
        const mainImage = gallery.querySelector('img');
        mainImage.src = photo.src;
        mainImage.alt = selected.value;
        gallery.querySelector('figcaption').textContent = selected.value;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
